import React from 'react';
import {
  CLIENT,
  FOURNISSEURS,
  PARAMETRE_PATH,
  PRODUCTS_PATH,
  SOLDES,
  TRANSACTION,
  //FACTURE,
  COMPTABILITE,
  FISCALITE,
  TRANSAC_PATH,
  CAISSEMOBILE_PATH,
  BANQUEMOBILE_PATH,
  WAVEMOBILE_PATH,
  OMMOBILE_PATH,
  // CREDIT_PATH,
  ASSISTANT_IA,
  VENTE,
  DEPENSE,
  FACTURATION,
  PIECES_COMPTABLES,
  SAISIE_MANUELLE,
} from './navigationPaths';
import { HiHome } from 'react-icons/hi';
import { MdAccountBalance, MdDashboard } from 'react-icons/md';
import { CgLayoutPin } from 'react-icons/cg';
import {
  RiArrowLeftRightLine,
  RiSettingsFill,
  RiUserAddLine,
  RiRobotLine,
  RiFileList3Line,
  RiFoldersLine,
  RiGovernmentLine,
  RiEditLine,
} from 'react-icons/ri';
import { FaRegFolderOpen, FaArrowDown, FaArrowUp } from 'react-icons/fa';
import bank from "../../image/Ellipse 19.png";
import batim from '../../image/Ellipse 18.png';
import wave from '../../image/Ellipse 17.png';
import orangeMoney from '../../image/Ellipse 16.png';
import { IoMdMenu } from 'react-icons/io';
/*
|--------------------------------------------------------------------------
! Sidebar Items
|--------------------------------------------------------------------------
|
| Here we can add sidebar links, paths and icons
|
*/
export const linksDossier = [
  { path: PRODUCTS_PATH, icon: HiHome, label: "Revenir à l'accueil" },
  { path: SOLDES, icon: MdDashboard, label: 'Tableau de Bord' },
  {
    path: TRANSACTION,
    icon: RiArrowLeftRightLine,
    label: 'Opérations',
    multiple: true,
    sous_links: [
      { path: VENTE, icon: FaArrowUp, label: 'Entrées' },
      { path: DEPENSE, icon: FaArrowDown, label: 'Sorties' },
      { path: TRANSACTION, icon: RiArrowLeftRightLine, label: 'Transactions' },
      { path: SAISIE_MANUELLE, icon: RiEditLine, label: 'Saisie manuelle' },
    ],
  },
  {
    path: CLIENT,
    icon: RiUserAddLine,
    label: 'Tiers',
    multiple: true,
    sous_links: [
      { path: CLIENT, icon: RiUserAddLine, label: 'Clients' },
      { path: FOURNISSEURS, icon: CgLayoutPin, label: 'Fournisseurs' },
    ],
  },
  {
    path: FACTURATION,
    icon: RiFileList3Line,
    label: 'Documents',
    multiple: true,
    sous_links: [
      { path: FACTURATION, icon: RiFileList3Line, label: 'Factures & Devis' },
      { path: PIECES_COMPTABLES, icon: RiFoldersLine, label: 'Pièces comptables' },
    ],
  },
  {
    path: COMPTABILITE,
    icon: MdAccountBalance,
    label: 'Pilotage',
    multiple: true,
    sous_links: [
      { path: COMPTABILITE, icon: MdAccountBalance, label: 'Comptabilité' },
      { path: FISCALITE, icon: RiGovernmentLine, label: 'Impôts & Fiscalité' },
    ],
  },
  { path: ASSISTANT_IA, icon: RiRobotLine, label: 'Assistant IA' },
  { path: PARAMETRE_PATH, icon: RiSettingsFill, label: 'Paramètres' },


  // { path: DETAIL_FOURNISSEURS_PATH, icon: RiPercentFill, label: "DETAIL" },
  //{ path: FACTURE, icon: HiHome, label: 'Facture' },
];

export const linksDossierMobiles = [
  { path: PRODUCTS_PATH, icon: HiHome, label: "Accueil" },
  { path: TRANSACTION, icon: RiArrowLeftRightLine, label: 'Transactions' },
  { path: ASSISTANT_IA, icon: RiRobotLine, label: "Assistant IA" },
  { path: COMPTABILITE, icon: MdAccountBalance, label: 'Comptabilité' },
  { path: FOURNISSEURS, icon: IoMdMenu, label: 'Tiers' },
  // { path: SOLDES, icon: MdDashboard, label: 'Tableau de Bord' },
  // { path: CLIENT, icon: RiUserAddLine, label: 'Clients' },
  // { path: PARAMETRE_PATH, icon: RiSettingsFill, label: 'Paramètres' },

  // { path: DETAIL_FOURNISSEURS_PATH, icon: RiPercentFill, label: "DETAIL" },
  //{ path: FACTURE, icon: HiHome, label: 'Facture' },
];

export const banques = [
    {path: TRANSAC_PATH, label: 'Tous les Comptes', icon: <FaRegFolderOpen size={20} />},
    {path: CAISSEMOBILE_PATH, label: 'Caisse', image: batim },
    {path: BANQUEMOBILE_PATH, label: 'Banque', image: bank },
    {path: WAVEMOBILE_PATH , label: 'Wave', image: wave },
    {path: OMMOBILE_PATH, label: 'Orange Money', image: orangeMoney },
  ];

